import { render, staticRenderFns } from "./DecorativeMediaImage.vue?vue&type=template&id=2338184a&scoped=true&"
import script from "./DecorativeMediaImage.vue?vue&type=script&lang=js&"
export * from "./DecorativeMediaImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2338184a",
  null
  
)

export default component.exports